/**
 * NavDropDown.js
 * Drop down component for Navbar
 *
 * @class   NavDropDown
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import ClickAway from 'mixins/js/ClickAway';
import Paper from 'components/paper/Paper';
import Menu from 'components/menu/Menu';
import DropDownArrow from 'components/svg-icons/drop-down-arrow';
import LinkMixin from 'mixins/js/LinkMixin';

import Router from 'react-router-component';
const Link = Router.Link;

export default React.createClass({

	mixins: [ ClickAway, LinkMixin ],

	manuallyBindClickAway: true,

	propTypes: {
		autoWidth: React.PropTypes.bool,
		onChange: React.PropTypes.func,
		menuItems: React.PropTypes.array.isRequired
	},

	getDefaultProps() {
		return {
			autoWidth: true
		};
	},

	getInitialState() {

		return {
			open: false,
			selectedIndex: 0
		}
	},

	componentWillUpdate(nextProps, nextState) {
		// initial state gets lost for a second for NavDropDown selectedIndex on navigation, not sure why
		// but this forces it back in.

		if (nextState.selectedIndex === undefined) {
			nextState.selectedIndex = this.state.selectedIndex;
		};
	},

	componentClickAway() {
		this.setState({
			open: false
		});
	},

	componentDidMount() {

		if (this.props.autoWidth) this._setWidth();
		if (this.props.hasOwnProperty('selectedIndex')) this._setSelectedIndex(this.props);
	},

	componentWillReceiveProps(nextProps) {
		if (this.props.hasOwnProperty('selectedIndex')) this._setSelectedIndex(nextProps);
	},

	componentDidUpdate(){
		if (this.state.open) {
			this._bindClickAway();
		} else {
			this._unbindClickAway();
		}
	},

	render() {
		console.log(this.getPath())
		var classes = ClassNames('lui-drop-down-menu', this.props.className, {
			'lui-open': this.state.open
		});

		return (
			<div className={classes}>

				<div className="lui-menu-control" onClick={this._onControlClick}>
					<Paper className="lui-menu-control-bg" depth={0} />
						<div className="lui-menu-label">
							{this.props.menuItems[this.state.selectedIndex].text}
						</div>
						<DropDownArrow className="lui-menu-drop-down-icon" />
						<div className="lui-menu-control-underline" />
				</div>

				<Menu
					ref="menuItems"
					autoWidth={this.props.autoWidth}
					selectedIndex={this.state.selectedIndex}
					menuItems={this.props.menuItems}
					hideable={true}
					visible={this.state.open}
					onItemClick={this._onMenuItemClick} />
			</div>
		);
	},

	_setWidth() {
		var el = React.findDOMNode(this),
			menuItemsDom = React.findDOMNode(this.refs.menuItems);

		el.style.width = menuItemsDom.offsetWidth + 'px';

	},

	_setSelectedIndex(props) {
		let selectedIndex = props.selectedIndex;

		if (process.NODE_ENV !== 'production' && selectedIndex < 0) {
			console.warn('Cannot set selectedIndex to a negative index.', selectedIndex);
		}

		this.setState({
			selectedIndex: (selectedIndex > -1) ? selectedIndex : 0
		});
	},

	_onControlClick(e) {
		this.setState({
			open: !this.state.open
		});
	},

	_onMenuItemClick(e, key, payload) {
		if (this.props.onChange && this.state.selectedIndex !== key) this.props.onChange(e, key, payload);
		this.setState({
			selectedIndex: key,
			open: false
		});
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/navbar/NavDropDown.js
 **/